<template>
  <div
    class="videoList-box"
    v-loading="exportLoading"
    element-loading-text="导出中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!--操作栏-->
    <div class="action-bar">
      状态:
      <el-select v-model="params.isActive" placeholder="状态" size="small">
        <el-option
          v-for="item in isActives"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option> </el-select
      >帖子类型:
      <el-select
        v-model.number="params.mediaType"
        placeholder="帖子类型"
        size="small"
        clearable
      >
        <el-option label="全部" :value="undefined"></el-option>
        <el-option label="视频" value="video"></el-option>
        <el-option label="视频广告" value="video_adv"></el-option>
        <el-option label="动漫" value="image"></el-option>
        <el-option label="小说" value="text"></el-option> </el-select
      >观看权限:
      <el-select v-model="params.permission" placeholder size="small">
        <el-option label="全部" :value="undefined"></el-option>
        <el-option label="会员" :value="0"></el-option>
        <el-option label="金币" :value="1"></el-option>
        <el-option label="免费" :value="2"></el-option>
      </el-select>
      <el-input
        v-model="params.tag"
        placeholder="请输入标签名"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.title"
        placeholder="请输入帖子标题"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.id"
        placeholder="请输入帖子ID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        v-model="params.zone"
        placeholder="请选择专区"
        size="small"
        clearable
        @change="searchKindMediaTopic"
      >
        <el-option
          v-for="s in zones"
          :key="s.value"
          :label="s.label"
          :value="s.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="params.mediaTopicId"
        placeholder="请选择专区下专题"
        size="small"
        clearable
      >
        <el-option
          v-for="m in mediaTopics"
          :key="m.id"
          :label="m.name"
          :value="m.id"
        >
        </el-option>
      </el-select>
      <!-- <el-select
        v-model="sectionIndex"
        placeholder="请选择新版模块"
        size="small"
        @change="changeSectionIndex"
      >
        <el-option
          v-for="(item, index) in sections"
          :key="index"
          :label="item.moduleName"
          :value="index"
        ></el-option>
      </el-select>
      <el-select
        v-model="parentSection"
        placeholder="请选择新版父专题"
        size="small"
        @change="changeSection"
      >
        <el-option
          v-for="(item, index) in parentSections"
          :key="index"
          :label="item.subModuleName"
          :value="index"
        ></el-option>
      </el-select>
      <el-select
        v-model="setData.section"
        placeholder="新版子专题"
        size="small"
      >
        <el-option
          v-for="item in subSections"
          :key="item.id"
          :label="item.sectionName"
          :value="item.id"
        ></el-option>
      </el-select> -->
      <el-cascader
        v-model="newSectionId"
        clearable
        :options="newTopics"
        :show-all-levels="false"
        size="small"
        @change="handleNewTopicChange"
      ></el-cascader>
      <!-- <el-select
        v-model="params.sectionId"
        filterable
        placeholder="新版专题"
        size="small"
        clearable
      >
        <el-option
          v-for="m in newTopics"
          :key="m.id"
          :label="m.sectionName"
          :value="m.id"
        >
        </el-option>
      </el-select> -->
      <el-checkbox
        v-if="params.mediaTopicId"
        v-model="params.isMediaTopic"
        :label="mediaTopicTitle"
        @change="handelMediaTopic()"
        style="margin-right:10px"
      ></el-checkbox>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="getMediaList('status')"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="exportList"
        :disabled="isDisabled"
        >导出</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchDelete('delete')"
        :disabled="isDisabled"
        >批量删除</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchRemove('remove')"
        :disabled="isDisabled"
        >批量移除专题</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchOverhead()"
        :disabled="isDisabled"
        >批量上架</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchTakeDown()"
        :disabled="isDisabled"
        >批量下架</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchSet()"
        :disabled="isDisabled"
        >批量设置</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
      height="580"
      @selection-change="handleSelectionChange"
      :key="updataSta"
    >
      <el-table-column
        type="selection"
        v-if="isSelection"
        width="55"
        fixed="left"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        label="帖子ID"
        align="center"
        width="220"
      ></el-table-column>
      <el-table-column
        prop="mediaType"
        label="帖子类型"
        align="center"
        width="80"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">
            {{ handlerMediaType(scope.row.mediaType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isActive"
            @change="setStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="permission"
        label="观看权限"
        align="center"
        min-width="80"
      >
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">
            {{ handelLookPermission(scope.row.permission) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="视频标题"
        align="center"
        :show-overflow-tooltip="true"
        width="250"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="横版封面图" align="center" width="80">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.horizontalCover"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column label="竖版封面图" align="center" width="80">
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="imgUrl + scope.row.verticalCover"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalEpisode"
        label="总集数"
        align="center"
        width="80"
      ></el-table-column>

      <el-table-column prop="url" label="预览" align="center" width="80">
        <template slot-scope="scope">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="previewMedia(scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="topic" label="专题" align="center" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.topic || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="topicName" label="专区" align="center" width="140">
        <template slot-scope="scope">
          <div>{{ scope.row.topicName || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subTopicName"
        label="话题"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.subTopicName || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="featuredName"
        label="精选专区话题"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.featuredName || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortCodeUnderSection"
        label="专题排序"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          {{ handelTopicSort(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sectionSort"
        label="新版专题排序"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        align="center"
        width="80"
        :sortable="'custom'"
      ></el-table-column>
      <el-table-column
        prop="countBrowse"
        label="播放数(真)"
        align="center"
        width="80"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.countBrowse || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="likeCount"
        label="点赞数(真)"
        align="center"
        width="80"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.countLike || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countCollect"
        label="收藏数"
        align="center"
        width="80"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.countCollect || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countPurchases"
        label="购买量"
        align="center"
        width="80"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.countPurchases || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countView"
        label="展现数"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="countPurchasesRate"
        label="成交率"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length"
            >未知</span
          >
          <div
            v-else
            class="picturePreview"
            @click="
              previewPicture(
                scope.row.seriesCover,
                scope.row.id,
                scope.row.tags
              )
            "
          >
            <el-image
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item, i) in scope.row.seriesCover"
              :key="i"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="tagObjs"
        label="标签"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tagObjs" :key="i" class="tagBox">
            <el-tag type="success" size="mini" effect="plain" class="tags">{{
              "#" + tag.name
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateStatus"
        label="更新状态"
        align="center"
        min-width="150"
        :formatter="handleUpdateSta"
      ></el-table-column>
      <el-table-column
        prop="updatedDesc"
        label="更新描述"
        align="center"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="sellType"
        label="售卖类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.sellType == 0">单集售卖</span>
          <span v-else-if="scope.row.sellType == 1">整部售卖</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="上传时间"
        align="center"
        width="160"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          ></el-button>
          <br />
          <el-button
            v-if="params && params.mediaTopicId"
            type="primary"
            size="mini"
            @click="setMediaTopic(scope.row)"
          >
            {{
              params.mediaTopicId ===
              (params.zone === "精选" ? scope.row.choice : scope.row.general)
                ? "移除当前专题"
                : "设置到专题"
            }}
          </el-button>
          <br />
          <el-button
            v-if="
              params.mediaTopicId ===
                (params.zone === '精选' ? scope.row.choice : scope.row.general)
            "
            type="success"
            size="mini"
            @click="setMediaTopicSort(scope.row)"
          >
            {{ "设置专题排序" }}
          </el-button>
          <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeVideo(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--视频编辑弹窗-->
    <edit-video
      ref="editVideo"
      @handlerVideoList="handlerVideoList"
    ></edit-video>
    <!--视频预览弹窗-->
    <preview-video
      ref="previewMedia"
      @handlerVideoList="handlerVideoList"
    ></preview-video>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
    <!-- 分页组件 -->
    <div class="bottom">
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="primary" size="mini" @click="subSection"
          >提交</el-button
        >
      </div>
      <div class="page">
        <el-pagination
          :page-sizes="[10, 25, 50, 100]"
          :current-page="params.pageNumber"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
    <comment-action ref="commentAction" @handleList="getVideoList('status')" />
    <el-dialog
      :title="
        batchContent == 'delete'
          ? '批量删除'
          : batchContent == 'remove'
          ? '批量移除'
          : batchContent == 'overhead'
          ? '批量上架'
          : '批量下架'
      "
      :visible.sync="isBatchDelete"
      width="1300px"
      @close="closeBatch"
    >
      <div class="optBox" v-if="batchContent == 'overhead'">
        <el-select
          class="zone"
          v-model="overheadZone"
          placeholder="请选择专区"
          size="small"
          clearable
          @change="searchMediaTopic"
        >
          <el-option
            v-for="s in overheadZones"
            :key="s.value"
            :label="s.label"
            :value="s.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="overheadMediaTopicId"
          placeholder="请选择专区下专题"
          size="small"
          clearable
        >
          <el-option
            v-for="m in overheadMediaTopics"
            :key="m.id"
            :label="m.name"
            :value="m.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-table
        :data="videoIds"
        highlight-current-row
        border
        class="batchdelete"
      >
        <el-table-column
          prop="id"
          label="帖子ID"
          align="center"
          min-width="220"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="mediaType"
          label="帖子类型"
          align="center"
          min-width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ handlerMediaType(scope.row.mediaType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isActive === true">上架</span>
            <span v-if="scope.row.isActive === false">下架</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="视频标题"
          align="center"
          :show-overflow-tooltip="true"
          min-width="250"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.title || "未知" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="横版封面" align="center" min-width="140">
          <template slot-scope="scope">
            <img-load
              :width="'60px'"
              :height="'80px'"
              :src="imgUrl + scope.row.horizontalCover"
            ></img-load>
          </template>
        </el-table-column>
        <el-table-column label="竖版封面" align="center" min-width="140">
          <template slot-scope="scope">
            <img-load
              :width="'60px'"
              :height="'80px'"
              :src="imgUrl + scope.row.verticalCover"
            ></img-load>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBatechDel">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmSubmit"
          :loading="isBatchDeleteLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="批量设置" :visible.sync="isBatchSet" @close="closeBatch">
      <el-form ref="form" :model="setData" :rules="rules" label-width="120px">
        <el-form-item label="模块:" prop="section">
          <el-select
            v-model="sectionIndex"
            placeholder="请选择模块"
            size="small"
            @change="changeSectionIndex"
          >
            <el-option
              v-for="(item, index) in sections"
              :key="index"
              :label="item.moduleName"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专题:" prop="section">
          <el-select
            v-model="parentSection"
            placeholder="请选择父专题"
            size="small"
            @change="changeSection"
          >
            <el-option
              v-for="(item, index) in parentSections"
              :key="index"
              :label="item.subModuleName"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子专题:" prop="section">
          <el-select
            v-model="setData.section"
            placeholder="子专题"
            size="small"
          >
            <el-option
              v-for="item in subSections"
              :key="item.id"
              :label="item.sectionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSetting">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmSetting"
          :loading="isBatchSetLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { paramsFilter } from '@/utils/global'
// import { paramsFilter } from "@/utils/global";
import MediaPopup from "@/components/media-popup";
import EditVideo from "./components/edit-media";
import PreviewVideo from "./components/preview-media";
import baseConfig from "@/utils/serverUrlConfig";
import { sortEscape, changeTime } from "@/utils/global";
import PreviewPicture from "./components/previewPicture";
import CommentAction from "@/components/commentAction";
import API from "@/api";
export default {
  data() {
    return {
      mediaTopicTitle: "查询包含当前专题",
      // 状态
      isActives: [
        {
          label: "上架",
          value: true,
        },
        {
          label: "下架",
          value: false,
        },
        {
          label: "全部状态",
          value: undefined,
        },
      ],
      imgUrl: baseConfig.imgUrl,
      loading: false,
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 10,
        permission: undefined,
        sectionId: undefined,
        key: "",
        value: "",
        start: "",
        end: "",
        title: "",
        tag: "",
        isActive: undefined,
        id: "",
        mediaType: undefined,
        zone: "",
        mediaTopicId: "",
        isMediaTopic: true,
      },
      exportLoading: false,
      isSelection: false,
      videoIds: [],
      zoneType: "",
      zones: [
        { label: "最新", value: "最新" },
        { label: "精选", value: "精选" },
        { label: "动漫", value: "动漫" },
        { label: "漫画", value: "漫画" },
        { label: "COS", value: "COS" },
        { label: "真人", value: "真人" },
        { label: "小说", value: "小说" },
        { label: "写真", value: "写真" },
        { label: "原作", value: "原作" },
      ],
      overheadZone: undefined,
      overheadMediaTopicId: undefined,
      newSectionId: [],
      newTopics: [],
      overheadMediaTopics: [],
      overheadZones: [
        { label: "精选", value: "精选" },
        { label: "动漫", value: "动漫" },
        { label: "漫画", value: "漫画" },
        { label: "COS", value: "COS" },
        { label: "真人", value: "真人" },
        { label: "小说", value: "小说" },
        { label: "写真", value: "写真" },
        { label: "原作", value: "原作" },
      ],
      mediaTopics: [],
      isDisabled: false,
      subSectionList: [],
      subSectionId: "",
      searchSubSections: "",
      searchSubSectionId: "",
      batchContent: "", // 批量操作的内容, featured-精选，''-专题
      isBatchDelete: false,
      deleteArr: [],
      isBatchDeleteLoading: false,
      // 批量修改是否推荐
      batchRecommend: "",
      updataSta: false,
      isBatchSet: false,
      isBatchSetLoading: false,
      sections: [],
      parentSections: [],
      subSections: [],
      sectionIndex: undefined,
      parentSection: undefined,
      setData: {
        originalSort: undefined,
        section: undefined,
      },
      // 表单验证规则
      rules: {
        section: [
          { required: true, message: "请输入专题列表ID", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    MediaPopup,
    EditVideo,
    PreviewVideo,
    PreviewPicture,
    CommentAction,
  },
  created() {
    this.getSections();
    // this.getNewTopics();
    this.getMediaList();
  },
  methods: {
    changeSectionIndex(index) {
      if (this.sections[index]) {
        this.parentSections = this.sections[index].subModule;
      } else {
        this.parentSections = [];
        this.parentSection = undefined;
      }
    },
    changeSection(index) {
      // console.log(index);
      // console.log(this.parentSections)
      if (this.parentSections[index]) {
        this.subSections = this.parentSections[index].sections;
      } else {
        this.subSections = [];
        this.setData.section = undefined;
      }
    },
    handleUpdateSta(row) {
      switch (row.updateStatus) {
        case 1:
          return "更新中";
        case 2:
          return "已完结";
        default:
          return "默认";
      }
    },
    handelLookPermission(permission) {
      switch (permission) {
        case 0:
          return "会员";
        case 1:
          return "金币";
        case 2:
          return "免费";
        default:
          return "-";
      }
    },
    handelTopicSort(row) {
      if (
        row.general !== "000000000000000000000000" &&
        this.zoneType !== "精选"
      ) {
        return row.generalSort;
      }
      if (
        row.choice !== "000000000000000000000000" &&
        this.zoneType == "精选"
      ) {
        return row.choiceSort;
      }
    },
    setMediaTopic(row) {
      if (!this.params.mediaTopicId) {
        this.$message.error("请先选择专题筛选数据后，再进行操作！");
        return;
      }
      //移除or设置
      let b =
        this.params.mediaTopicId ===
        (this.params.zone === "精选" ? row.choice : row.general);
      if (b) {
        let req = {
          id: row.id,
          zone: this.params.zone,
        };
        this.$confirm(`确认是否移除, 是否继续?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }).then(() => {
          API.editMediaInfo(req)
            .then((ret) => {
              if (ret.code === 200) {
                this.$message({
                  type: "success",
                  message: "取消成功",
                });
                this.getMediaList();
              } else {
                this.$message({
                  type: "error",
                  message: "取消失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消",
              });
            });
        });
      } else {
        this.$prompt("请输入视频在专题中的排序", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[0-9]\d*$/,
          inputErrorMessage: "请输入正整数",
        })
          .then(async ({ value }) => {
            let req = {
              id: row.id,
              mediaTopicId: this.params.mediaTopicId,
              zone: this.params.zone,
              mediaTopicSort: Number(value),
            };
            let ret = await API.editMediaInfo(req);
            if (ret.code === 200) {
              this.$message({
                type: "success",
                message: "设置成功",
              });
              this.getMediaList();
            } else {
              this.$message({
                type: "error",
                message: "设置失败",
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消",
            });
          });
      }
    },
    setMediaTopicSort(row) {
      if (!this.params.mediaTopicId) {
        this.$message.error("请先选择专题筛选数据后，再进行操作！");
        return;
      }
      this.$prompt("请输入视频在专题中的排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(async ({ value }) => {
          let req = {
            id: row.id,
            mediaTopicId: this.params.mediaTopicId,
            zone: this.params.zone,
            mediaTopicSort: Number(value),
          };
          let ret = await API.editMediaInfo(req);
          if (ret.code === 200) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.getMediaList();
          } else {
            this.$message({
              type: "error",
              message: "设置失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },

    // 确认批量删除
    async confirmBatechDel() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchDelMedia(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    // 确认批量移除
    async confirmRemove() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchRemoveToicp(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "移除成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("移除失败！");
      }
    },
    confirmSubmit() {
      if (this.batchContent == "overhead") {
        this.confirmOverhead();
      } else if (this.batchContent == "remove") {
        this.confirmRemove();
      } else if (this.batchContent == "takeDown") {
        this.confirmTakeDown();
      } else if (this.batchContent == "delete") {
        this.confirmBatechDel();
      }
    },
    // 确认批量下架
    async confirmTakeDown() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        field: "isActive",
        ids: videoIDs,
        status: false,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.setMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "下架成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    async confirmSetting() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        field: "isActive",
        ids: videoIDs,
        section: this.setData.section,
        general:
          this.overheadZone != "精选" ? this.overheadMediaTopicId : undefined,
        choice:
          this.overheadZone == "精选" ? this.overheadMediaTopicId : undefined,
      };
      if (this.overheadZone && !this.overheadMediaTopicId) {
        this.$message({
          message: "请选择专题",
          type: "error",
        });
        return;
      }
      this.isBatchSetLoading = true;
      let ret = await API.setMediaStatus(req);
      this.isBatchSetLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("设置失败！");
      }
    },
    getSections() {
      API.sectionList({}).then((res) => {
        console.log(res);
        if (res && res.code === 200) {
          this.sections = res.data.modules;
          this.newTopics =
            res.data.modules && res.data.modules.length
              ? [].concat(res.data.modules)
              : [];
          console.log(this.newTopics);
          this.newTopics.forEach((item) => {
            item.value = item.moduleName;
            item.label = item.moduleName;
            item.children = item.subModule || [];
            item.children.forEach((i) => {
              i.value = i.id;
              i.label = i.subModuleName;
              i.children = i.sections || [];
              i.children.forEach((j) => {
                j.label = j.sectionName;
                j.value = j.id;
              });
            });
          });
          // console.log(this.newTopics)
          // console.log(this.sections);
        }
      });
    },
    handleNewTopicChange(value) {
      this.params.sectionId = value[2];
      // console.log(this.newSectionId)
    },
    // 确认批量上架
    async confirmOverhead() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        field: "isActive",
        ids: videoIDs,
        status: true,
        general:
          this.overheadZone != "精选" ? this.overheadMediaTopicId : undefined,
        choice:
          this.overheadZone == "精选" ? this.overheadMediaTopicId : undefined,
      };
      if (this.overheadZone && !this.overheadMediaTopicId) {
        this.$message({
          message: "请选择专题",
          type: "error",
        });
        return;
      }
      this.isBatchDeleteLoading = true;
      let ret = await API.setMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "上架成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    cancelBatechDel() {
      this.isBatchDelete = false;
    },
    cancelSetting() {
      this.isBatchSet = false;
    },
    // 批量删除
    async batchDelete() {
      this.batchContent = "delete";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量移除专题
    async batchRemove() {
      this.batchContent = "remove";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量设置
    batchSet() {
      this.batchContent = "setting";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量下架
    batchTakeDown() {
      this.batchContent = "takeDown";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量上架
    batchOverhead() {
      this.batchContent = "overhead";
      this.isSelection = true;
      this.isDisabled = true;
    },
    selectChild(val) {
      this.subSectionList = val;
      this.subSectionId = "";
    },
    subSection() {
      if (this.videoIds.length == 0) {
        this.$message.error("请至少选择一条数据");
        return;
      }
      if (this.batchContent === "featured") {
        this.isFeatured = true;
      } else if (
        this.batchContent === "overhead" ||
        this.batchContent === "takeDown" ||
        this.batchContent === "delete" ||
        this.batchContent === "remove"
      ) {
        this.isBatchDelete = true;
      } else if (this.batchContent === "setting") {
        this.isBatchSet = true;
      } else if (this.batchContent === "recommend") {
        this.isRecommendSta = true;
      } else {
        this.dialogVisible = true;
      }
    },
    //获取种类下媒体话题
    searchKindMediaTopic() {
      if (this.params.zone === undefined) {
        this.$message.error("请选择专区");
        return;
      }
      var param = {
        active: true,
        zone: this.params.zone,
        pageNumber: 1,
        pageSize: 50,
      };
      API.getDmSections(param)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.mediaTopics = res.data.list;
          } else {
            this.mediaTopics = [];
          }
        })
        .catch(() => {
          this.mediaTopics = [];
        });
    },
    //获取种类下媒体话题
    searchMediaTopic() {
      if (this.params.zone === undefined) {
        this.$message.error("请选择专区");
        return;
      }
      var param = {
        active: true,
        zone: this.overheadZone,
        pageNumber: 1,
        pageSize: 50,
      };
      API.getDmSections(param)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.overheadMediaTopics = res.data.list;
          } else {
            this.overheadMediaTopics = [];
          }
        })
        .catch(() => {
          this.overheadMediaTopics = [];
        });
    },
    exportList() {
      let req = JSON.parse(JSON.stringify(this.params));
      this.exportLoading = true;
      API.exportMediaList(req)
        .then((res) => {
          if (res) {
            try {
              var blob = new Blob([res], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
              }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
              var downloadElement = document.createElement("a");
              var href = window.URL.createObjectURL(blob); // 创建下载的链接
              downloadElement.href = href;
              downloadElement.download = "动漫列表.xlsx"; // 下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); // 点击下载
              document.body.removeChild(downloadElement); // 下载完成移除元素
              window.URL.revokeObjectURL(href); // 释放掉blob对象
            } catch (error) {
              console.log(error);
              this.$message.error("导出失败！");
            }
          }
        })
        .catch(() => {
          this.$message.error("导出失败！");
        })
        .finally(() => {
          this.exportLoading = false;
        });
      // let param = Object.assign({}, this.params);
      // let params = paramsFilter(param);
      // let str = "";
      // for (let key in params) {
      //   if (key == "startTime" || key == "endTime") {
      //     params[key] = params[key].replace("+", "%2B");
      //   }
      //   str += key + "=" + params[key] + "&";
      // }
      // str = str.substring(0, str.length - 1);

      // let url = baseConfig.baseServerUrl + "/media/list/export?" + str;
      // window.location.href = url;
      // API.exportMediaList(this.params)
      //   .then((res) => {
      //     console.log(res);
      // if (res.code === 200 && res.data.vInfos) {
      //   this.zoneType = this.params.zone;
      //   this.tableData = res.data.vInfos;
      //   this.total = res.data.total;
      //   if (this.isDisabled) {
      //     this.restoreCheckedState();
      //   }
      // } else {
      //   this.tableData = [];
      //   this.total = 0;
      // }
      // this.loading = false;
      // })
      // .catch(() => {
      //   this.tableData = [];
      //   this.loading = false;
      // });
    },
    // 获取视频列表
    getMediaList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getMediaList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.vInfos) {
            this.zoneType = this.params.zone;
            this.tableData = res.data.vInfos;
            this.total = res.data.total;
            if (this.isDisabled) {
              this.restoreCheckedState();
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 获取视频列表
    getNewTopics() {
      let req = {
        pageSize: 399,
        pageNumber: 1,
        status: 1,
      };
      API.getNewTopics(req)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.newTopics = res.data.list;
          } else {
            this.newTopics = [];
          }
        })
        .catch(() => {
          this.newTopics = [];
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getMediaList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getMediaList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getMediaList("status");
    },
    // 编辑回调监听
    handlerVideoList() {
      this.getMediaList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getMediaList();
    },
    handelMediaTopic() {
      if (!this.params.isMediaTopic) {
        this.mediaTopicTitle = "查询不包含当前专题";
      } else {
        this.mediaTopicTitle = "查询包含当前专题";
      }
    },
    // 图集预览
    previewPicture(pictureArr, id, tags) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, tags);
    },
    //更新媒体状态
    setStatus(row) {
      row.isActive = !row.isActive;
      let text = row.isActive ? "您确定要下架吗？" : "您确定要上架吗？";
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.id,
          isActive: !row.isActive,
        };
        API.editMediaInfo(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.getMediaList();
            } else {
              this.$message.error("操作失败！");
            }
            this.flag = false;
            this.getMediaList();
          })
          .catch(() => {
            this.flag = false;
          });
      });
    },
    handlerPreviewList() {
      this.getMediaList();
    },
    handlerMediaType(mediaType) {
      switch (mediaType) {
        case "video":
          return "视频";
        case "video_adv":
          return "视频广告";
        case "image":
          return "漫画";
        case "text":
          return "小说";
      }
    },
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    // 删除视频
    removeVideo(id) {
      this.$confirm("您确定要删除当当前视频吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteVideo({ ids: [id] }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getMediaList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 编辑视频
    edit(row) {
      this.$refs.editVideo.open(row);
    },
    // 预览
    previewMedia(row) {
      this.$refs.previewMedia.open(row);
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.videoIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    openSelection(param) {
      this.batchContent = param ? param : "featured";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 查询视频所属专题
    getVideoModule() {
      var p = {
        pageNumber: 1,
        pageSize: 10000,
      };
      if (this.tableData.length <= 0) {
        this.$message({
          type: "warn",
          message: "当前页面无数据",
        });
        return;
      }
      //获取视频id
      var videoIds = [];
      for (const v of this.tableData) {
        videoIds.push(v.id);
      }
      if (videoIds.length <= 0) {
        this.$message({
          type: "warn",
          message: "当前页面视频Id为空",
        });
        return;
      }
      p.videoid = videoIds;
      API.getVideos(p)
        .then((res) => {
          if (
            res.code === 200 &&
            res.data &&
            res.data.list &&
            res.data.list.length > 0
          ) {
            this.tableData.forEach((i) => {
              res.data.list.forEach((j) => {
                if (i.id == j.videoID) {
                  if (i.topic === undefined) i.topic = j.sectionName;
                  else i.topic = i.topic + ", " + j.sectionName;
                }
              });
            });
            this.updataSta = !this.updataSta;
          } else {
            this.$message.error("当前页无专题");
          }
        })
        .catch(() => {
          console.log("查询当前页面视频所属专题异常!");
        });
    },
    uploadSection() {
      let videoIDs = this.videoIds.map((item) => item.id);
      videoIDs = videoIDs.toString();
      let req = {
        sectionID: this.subSectionId,
        videoIDs: videoIDs,
      };
      API.batch(req)
        .then((res) => {
          if (res && res.code === 200) {
            this.$message.success("上传成功");
          } else {
            this.$message.error("上传失败");
          }
          this.giveUp();
          this.close();
          this.getMediaList();
        })
        .catch((err) => {
          this.$message.err("上传失败" + err);
        });
    },
    giveUp() {
      this.batchContent = "";
      this.isDisabled = false;
      this.isSelection = false;
      this.subSections = "";
      this.subSectionId = "";
      this.setData.section = undefined;
      this.videoIds = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 关闭窗口
    close() {
      this.isBatchSet = false;
      this.isBatchDelete = false;
    },
    closeRecommend() {
      this.batchRecommend = "";
    },
    closeBatch() {
      this.setData.section = undefined;
      this.sectionIndex = undefined;
      this.parentSection = undefined;
      this.parentSections = [];
      this.subSections = [];
      // this.sections = [];
      this.overheadMediaTopicId = undefined;
      this.overheadZone = undefined;
    },
  },
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}
.videoList-box {
  min-height: 100vh;
  overflow-y: auto;
}
.bottom {
  margin-top: 20px;
  .btn {
    display: inline-block;
    margin-left: 20px;
  }
  .page {
    display: inline-block;
    float: right;
  }
}
.el-pagination {
  margin-top: 0 !important;
}
.dialog-footer {
  left: 0;
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
.optBox {
  margin-bottom: 20px;
}
.zone {
  margin-right: 20px;
}
</style>
